/**
 *
 * AlertList
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert } from 'react-bootstrap';
import withAlerts from 'containers/AlertService/withAlerts';
import * as colors from 'styles/colors';
import IntlString from 'components/IntlString';

export const ControlAlert = styled(Alert)`
  &.alert {
    border: 2px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
    background-color: ${colors.white};
    margin-bottom: 10px;
    @media (min-width: 768px) {
      min-width: 400px;
    }
    h4 {
      margin-bottom: 0;
      font-size: 1.6rem;
      line-height: 1.65;
    }
    &.alert-danger {
      margin-left: 0;
      border-color: ${colors.red700};
    }
    &.alert-warning {
      margin-left: 0;
      border-color: ${colors.orange700};
    }
    &.alert-success {
      margin-left: 0;
      border-color: ${colors.green700};
    }
    &.alert-info {
      margin-left: 0;
      border-color: ${colors.blue700};
    }
  }
`;

const MapAlert = styled(ControlAlert)`
  &.alert {
    padding-right: 35px;
    margin-left: 10px;
  }
`;

class AlertList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.specialStyles = ['danger', 'success'];
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss(id) {
    const { dismissAlert } = this.props;
    return () => {
      dismissAlert(id);
    };
  }

  renderStyle(style) {
    const { alerts } = this.props;
    const className = style
      ? `alertlist alertlist-${style}`
      : 'alertlist alertlist-default';
    const filter = alert =>
      style ? alert.style === style : !this.specialStyles.includes(alert.style);
    const filteredAlerts = alerts.filter(filter);
    if (filteredAlerts.length === 0) {
      return null;
    }
    return (
      <div className={className}>
        {filteredAlerts.map(alert => (
          <MapAlert
            key={alert.id}
            bsStyle={alert.style}
            onDismiss={this.handleDismiss(alert.id)}
          >
            <h4>
              <IntlString message={alert.title} />
            </h4>
            {alert.description && <p>{alert.description}</p>}
          </MapAlert>
        ))}
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderStyle()}
        {this.renderStyle('danger')}
        {this.renderStyle('success')}
      </React.Fragment>
    );
  }
}

AlertList.propTypes = {
  alerts: PropTypes.array.isRequired,
  dismissAlert: PropTypes.func.isRequired,
};

export default withAlerts(AlertList);
